module.exports = __webpack_public_path__ + "static/img/iQMS-icon.0950b6e4.png";